import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'cms-drawer',
    templateUrl: './cms-drawer.component.html',
    styleUrls: ['./cms-drawer.component.scss'],
    standalone: false,
})
export class CmsDrawerComponent implements OnChanges, OnDestroy {
    @Input() open = false;
    @Input() disableBackdropClose = true;
    @Input() drawerId: string | null = null;

    @Output() closed = new EventEmitter<void>();

    constructor(@Inject(DOCUMENT) private document: Document) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['open']) {
            this.syncBodyClass();
        }
    }

    ngOnDestroy(): void {
        this.document.body.classList.remove('cms-drawer-open');
    }

    public onCloseClick(): void {
        this.closed.emit();
    }

    public onBackdropClick(event: MouseEvent): void {
        if (this.disableBackdropClose) {
            return;
        }
        if ((event.target as HTMLElement).classList.contains('cms-overlay-backdrop')) {
            this.closed.emit();
        }
    }

    private syncBodyClass(): void {
        this.document.body.classList.toggle('cms-drawer-open', this.open);
    }
}
